import { render, staticRenderFns } from "./ACreateResource.vue?vue&type=template&id=5159b3d0&"
import script from "./ACreateResource.vue?vue&type=script&lang=js&"
export * from "./ACreateResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports